import React, { useEffect, useState } from "react";
import Topbar from "../components/Topbar";
import Sidebar from "../components/Sidebar";
import { Link, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import axios from "axios";

function UpdateShippingCharge() {
  const { id } = useParams();
  const navigate = useNavigate();
  const token = sessionStorage.getItem("token");
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    Pincode: "",
    Shipping_Amount: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "Pincode" && !/^\d*$/.test(value)) return;
    setFormData({ ...formData, [name]: value });
  };

  const validateForm = () => {
    if (!/^\d{6}$/.test(formData.Pincode)) {
      toast.error("Pincode must be a 6-digit number.");
      return false;
    }

    if (parseFloat(formData.Shipping_Amount) <= 0) {
      toast.error("Shipping amount must be greater than 0.");
      return false;
    }
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    setLoading(true);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_APIURL}api/updateshipping/${id}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(formData),
        }
      );

      const data = await response.json();

      if (response.ok) {
        toast.success("Shipping charge Update successfully!");
        navigate("/shippingchargeslist");
        setFormData({ Pincode: "", Shipping_Amount: "" });
      } else {
        toast.error(data.message || "Failed to Update Shipping Charge");
      }
    } catch (error) {
      toast.error("Something went wrong! Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const fetchSingleShipping = async () => {
      if (!token) {
        toast.error("No token provided!");
        return;
      }

      try {
        const response = await axios.get(
          `${process.env.REACT_APP_APIURL}api/shippingdetails/${id}`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (response.data?.data) {
          setFormData({
            Pincode: response.data.data.Pincode,
            Shipping_Amount: response.data.data.Shipping_Amount,
          });
        }
      } catch (error) {
        toast.error(
          "Error fetching data: " +
            (error.response?.data?.message || error.message)
        );
      }
    };

    fetchSingleShipping();
  }, [id, token]);

  return (
    <>
      <Topbar />
      <Sidebar />
      <main id="main" className="main">
        <div className="pagetitle">
          <h1>Shipping Charge</h1>
          <nav>
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link to="/">Home</Link>
              </li>
              <li className="breadcrumb-item active">Update Shipping Charge</li>
            </ol>
          </nav>
        </div>

        <div className="card">
          <div className="card-body">
            <form className="row g-3 pt-4" onSubmit={handleSubmit}>
              <div className="col-md-4">
                <div className="form-floating">
                  <input
                    type="text"
                    className="form-control"
                    id="pin_code"
                    placeholder="Enter Pin Code"
                    name="Pincode"
                    value={formData.Pincode}
                    onChange={handleChange}
                    maxLength="6"
                    required
                  />
                  <label htmlFor="pin_code">Postal Code</label>
                </div>
              </div>
              <div className="col-md-4">
                <div className="form-floating">
                  <input
                    type="number"
                    className="form-control"
                    id="Shipping_Amount"
                    placeholder="Enter Shipping Amount"
                    name="Shipping_Amount"
                    value={formData.Shipping_Amount}
                    onChange={handleChange}
                    required
                  />
                  <label htmlFor="Shipping_Amount">Shipping Amount</label>
                </div>
              </div>
              <div className="text-start d-flex gap-3 mt-4">
                <button
                  type="submit"
                  className="btn btn-primary"
                  disabled={loading}
                >
                  {loading ? "Adding..." : "Update Shipping Charge"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </main>
    </>
  );
}

export default UpdateShippingCharge;
